import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

/* ------------------------------------------------------------------
   Homepage intro replay control — runs BEFORE React mounts so we can
   beat the browser's automatic scroll restoration on reloads.
   ------------------------------------------------------------------ */
(function setupHomeIntroControl() {
  if (typeof window === "undefined") return;
  try {
    // Capture the path the document was originally loaded on. This is
    // stable across SPA route changes; only a full document load/reload
    // changes it.
    const initialPath = window.location.pathname;
    window.__THS_INITIAL_PATH__ = initialPath;

    const isHome =
      initialPath === "/" || initialPath === "/hero-light-study";
    const navType =
      performance.getEntriesByType &&
      performance.getEntriesByType("navigation")[0]?.type;

    if (isHome && navType === "reload") {
      // Manual reload of the homepage — suppress scroll restoration
      // and reset to the top so the intro can play cleanly from the
      // hero. Restore default scroll-restoration semantics shortly
      // after, so other pages and future navigations behave normally.
      if ("scrollRestoration" in history) {
        history.scrollRestoration = "manual";
      }
      window.scrollTo(0, 0);
      // Also clear the "intro has been seen" flag so a manual reload
      // is always treated as a fresh first viewing of the homepage.
      try {
        sessionStorage.removeItem("ths_home_intro_seen");
      } catch (_e) {
        /* sessionStorage unavailable — non-fatal */
      }
      // Hand scroll restoration back to the browser for subsequent
      // SPA navigations so /work, /press, etc. behave normally.
      window.setTimeout(() => {
        if ("scrollRestoration" in history) {
          history.scrollRestoration = "auto";
        }
      }, 1200);
    }
  } catch (_e) {
    /* Defensive: never block app boot for this. */
  }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
